import { config } from '@js/state';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({ key: 'StartScene' });
  }

  preload() {}

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    disablePointerEvents();
    config.audio.bgaudio = this.sound.add('bgMusic');
    this.addSprites();
    this.playButtonEvents();
  }

  addSprites() {
    this.startAnim = this.add.sprite(config.width / 2, config.height / 2, 'startAnim');

    this.anims.create({
      key: 'loop',
      frames: this.anims.generateFrameNames('startAnim', {
        start: 0,
        end: 119,
        zeroPad: 0,
        prefix: 'HOMESCREEN0',
        suffix: '.png',
      }),
      frameRate: 25,
      repeat: -1,
    });

    this.startAnim.play('loop');

    this.add.sprite(506, 111, 'gameName').setOrigin(0);
    this.playButton = this.add
      .sprite(config.width / 2, 300, 'playButton')
      .setOrigin(0.5)
      .setInteractive({ cursor: 'pointer' });
  }

  playButtonEvents() {
    this.playButton.on(
      'pointerover',
      () => {
        this.playButton.setTexture('playHover');
      },
      this,
    );
    this.playButton.on(
      'pointerout',
      () => {
        this.playButton.setTexture('playButton');
      },
      this,
    );
    this.playButton.on(
      'pointerup',
      () => {
        this.playButton.setScale(1);
        this.playButton.disableInteractive();
      },
      this,
    );

    this.playButton.on(
      'pointerdown',
      () => {
        enablePointerEvents();
        this.playButton.setScale(0.95);

        this.time.delayedCall(
          500,
          function () {
            this.cameras.main.fadeOut(500, 255, 255, 255);

            this.cameras.main.once(
              'camerafadeoutcomplete',
              function () {
                this.scene.stop('StartScene');
                this.scene.start('TutorialScene');
              },
              this,
            );
          },
          [],
          this,
        );
      },
      this,
    );
  }

  update() {}
}
